import React, {ReactNode} from 'react';
import PokerMainPot from 'app/components/poker/poker_pot/PokerMainPot';
import {formatCurrency} from 'app/utils/balance/formatCurrency';
import PokerSidePot from 'app/components/poker/poker_pot/PokerSidePot';
import {PotInterface} from 'app/interfaces/poker/TableInterface';

interface Props {
    pots: PotInterface[]
    playmoney: boolean
}

const BANKS_LIMIT = 2;

export default class PokerPot extends React.Component<Props> {
    renderSideBanks(): ReactNode {
        const pots = this.props.pots?.filter(p => p.main === false) || [];

        if (pots.length === 0) {
            return <></>;
        }

        if (pots.length <= BANKS_LIMIT) {
            return <div className="poker-side-pots-group">
                <div className="poker-side-pots">
                    {pots.map((p, i) => <PokerSidePot key={`${i}potf`} amount={p.amount}/>)}
                </div>
            </div>;
        }

        const firstTwo = pots.slice(0, BANKS_LIMIT);
        const rest = pots.slice(BANKS_LIMIT);

        return <div className="poker-side-pots-group">
            <div className="poker-side-pots">
                {firstTwo.map((p, i) => <PokerSidePot key={`${i}potf`} amount={p.amount}/>)}
            </div>
            <div className="poker-side-pots">
                {rest.map((p, i) => <PokerSidePot key={`${i}potr`} amount={p.amount}/>)}
            </div>
        </div>;
    }

    render(): ReactNode {
        const {pots, playmoney} = this.props;
        const pot = pots?.find(p => p.main === true)?.amount || 0;

        return <div className="poker-pot">
            <PokerMainPot value={formatCurrency(pot, playmoney)}/>
            {this.renderSideBanks()}
        </div>;
    }
}
